<div class="media-item-container clearfix" (click)="selectMedia($event, item)" [ngClass]="{ 'edit': item.editing }">
  <div class="media-image" [ngStyle]="{'background-image': 'url(' + item.media.sizes.small.url + ')'}"></div>
  <span *ngIf="!item.editing" class="title">{{item.title}}</span>
  <div class="edit-input">
    <input autofocus (keyup.enter)="save($event, item)" [hidden]="!item.editing" #editMediaInput type="text" class="form-control folder-input" [(ngModel)]="tmpMediaTitle" placeholder="New Media Name"/>
  </div>

  <div *ngIf="item.editing" (click)="stopProp($event)" class="folder-menu">
    <span (click)="$event.stopPropagation();item.editing=false" class="fa fa-times-circle-o fa-2x cancel"></span>
    <span (click)="save($event, item)" [ngClass]="{'disabled' : !tmpMediaTitle}" class="fa fa-check-circle fa-2x"></span>
  </div>

  <div *ngIf="!item.editing" (click)="stopProp($event)" class="folder-menu">
    <div ngbDropdown class="d-inline-block dropup" [placement]="'top'">
      <span class="fa fa-ellipsis-h toggle-points" id="folderMenu" ngbDropdownToggle></span>
      <div class="dropdown-menu dropdown-menu-right" aria-labelledby="folderMenu">
        <button class="dropdown-item" (click)="editMode($event, item)"><i class="fa fa-pencil"></i> Edit Name</button>
        <!--button class="dropdown-item"><i class="fa fa-files-o"></i> Duplicate</button-->
        <button class="dropdown-item" (click)="delete($event, item)"><i class="fa fa-trash"></i> Delete</button>
      </div>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/media-library/browse-media/media-item/media-item.component.html